var ibanMask = function($obj) {
    var schema = {
        'default': {'placeholder': 'AA  -  Geben Sie den Ländercode ein', 'mask': 'AA'},
        'AD': {'placeholder': 'ADNN NNNN NNNN XXXX XXXX XXXX', 'mask': 'AA99 9999 9999 **** **** ****'},
        'AE': {'placeholder': 'AENN NNNN NNNN NNNN NNNN NNN', 'mask': 'AA99 9999 9999 9999 9999 999'}, 	
        'AL': {'placeholder': 'ALNN NNNN NNNN XXXX XXXX XXXX XXXX', 'mask': 'AA99 9999 9999 **** **** **** ****'}, 	
        'AT': {'placeholder': 'ATNN NNNN NNNN NNNN NNNN', 'mask': 'AA99 9999 9999 9999 9999'}, 	
        'AZ': {'placeholder': 'AZNN AAAA XXXX XXXX XXXX XXXX XXXX', 'mask': 'AA99 AAAA **** **** **** **** ****'},
        'BA': {'placeholder': 'BANN NNNN NNNN NNNN NNNN', 'mask': 'AA99 9999 9999 9999 9999'}, 	
        'BE': {'placeholder': 'BENN NNNN NNNN NNNN', 'mask': 'AA99 9999 9999 9999'}, 	
        'BG': {'placeholder': 'BGNN AAAA NNNN NNXX XXXX XX', 'mask': 'AA99 AAAA 9999 99** **** **'}, 	
        'BH': {'placeholder': 'BHNN AAAA XXXX XXXX XXXX XX', 'mask': 'AA99 AAAA **** **** **** **'}, 	
        'BR': {'placeholder': 'BRNN NNNN NNNN NNNN NNNN NNNN NNNA X', 'mask': 'AA99 9999 9999 9999 9999 9999 999A *'}, 	
        'CH': {'placeholder': 'CHNN NNNN NXXX XXXX XXXX X', 'mask': 'AA99 9999 9*** **** **** *'}, 	
        'CR': {'placeholder': 'CRNN NNNN NNNN NNNN NNNN N', 'mask': 'AA99 9999 9999 9999 9999 9'}, 	
        'CY': {'placeholder': 'CYNN NNNN NNNN XXXX XXXX XXXX XXXX', 'mask': 'AA99 9999 9999 **** **** **** ****'}, 	
        'CZ': {'placeholder': 'CZNN NNNN NNNN NNNN NNNN NNNN', 'mask': 'AA99 9999 9999 9999 9999 9999'}, 	
        'DE': {'placeholder': 'DENN NNNN NNNN NNNN NNNN NN', 'mask': 'AA99 9999 9999 9999 9999 99'}, 	
        'DK': {'placeholder': 'DKNN NNNN NNNN NNNN NN', 'mask': 'AA99 9999 9999 9999 99'}, 	
        'DO': {'placeholder': 'DONN XXXX NNNN NNNN NNNN NNNN NNNN', 'mask': 'AA99 **** 9999 9999 9999 9999 9999'}, 	
        'EE': {'placeholder': 'EENN NNNN NNNN NNNN NNNN', 'mask': 'AA99 9999 9999 9999 9999'}, 	
        'ES': {'placeholder': 'ESNN NNNN NNNN NNNN NNNN NNNN', 'mask': 'AA99 9999 9999 9999 9999 9999'}, 	
        'FI': {'placeholder': 'FINN NNNN NNNN NNNN NN', 'mask': 'AA99 9999 9999 9999 99'}, 	
        'FR': {'placeholder': 'FRNN NNNN NNNN NNXX XXXX XXXX XNN', 'mask': 'AA99 9999 9999 99** **** **** X99'}, 		
        'FO': {'placeholder': 'FONN NNNN NNNN NNNN NN', 'mask': 'AA99 9999 9999 9999 99'}, 	
        'GB': {'placeholder': 'GBNN AAAA NNNN NNNN NNNN NN', 'mask': 'AA99 AAAA 9999 9999 9999 99'}, 	
        'GE': {'placeholder': 'GENN AANN NNNN NNNN NNNN NN', 'mask': 'AA99 AA99 9999 9999 9999 99'}, 	
        'GI': {'placeholder': 'GINN AAAA XXXX XXXX XXXX XXX', 'mask': 'AA99 AAAA **** **** **** ***'}, 	
        'GL': {'placeholder': 'GLNN NNNN NNNN NNNN NN', 'mask': 'AA99 9999 9999 9999 99'}, 	
        'GR': {'placeholder': 'GRNN NNNN NNNX XXXX XXXX XXXX XXX', 'mask': 'AA99 9999 99N* **** **** **** ***'}, 	
        'GT': {'placeholder': 'GTNN XXXX XXXX XXXX XXXX XXXX XXXX', 'mask': 'AA99 **** **** **** **** **** ****'}, 	
        'HR': {'placeholder': 'HRNN NNNN NNNN NNNN NNNN N', 'mask': 'AA99 9999 9999 9999 9999 9'}, 	
        'HU': {'placeholder': 'HUNN NNNN NNNN NNNN NNNN NNNN NNNN', 'mask': 'AA99 9999 9999 9999 9999 9999 9999'}, 	
        'IE': {'placeholder': 'IENN AAAA NNNN NNNN NNNN NN', 'mask': 'AA99 AAAA 9999 9999 9999 99'}, 	
        'IL': {'placeholder': 'ILNN NNNN NNNN NNNN NNNN NNN', 'mask': 'AA99 9999 9999 9999 9999 999'}, 	
        'IS': {'placeholder': 'ISNN NNNN NNNN NNNN NNNN NNNN NN', 'mask': 'AA99 9999 9999 9999 9999 9999 99'}, 	
        'IT': {'placeholder': 'ITNN ANNN NNNN NNNX XXXX XXXX XXX', 'mask': 'AA99 A999 9999 999* **** **** ***'}, 	
        'JO': {'placeholder': 'JONN AAAA NNNN XXXX XXXX XXXX XXXX XX', 'mask': 'AA99 AAAA 9999 **** **** **** **** **'}, 	
        'KW': {'placeholder': 'KWNN AAAA XXXX XXXX XXXX XXXX XXXX XX', 'mask': 'AA99 AAAA **** **** **** **** **** **'}, 	
        'KZ': {'placeholder': 'KZNN NNNX XXXX XXXX XXXX', 'mask': 'AA99 999* **** **** ****'}, 	
        'LB': {'placeholder': 'LBNN NNNN XXXX XXXX XXXX XXXX XXXX', 'mask': 'AA99 9999 **** **** **** **** ****'}, 	
        'LI': {'placeholder': 'LINN NNNN NXXX XXXX XXXX X', 'mask': 'AA99 9999 9*** **** **** *'}, 	
        'LT': {'placeholder': 'LTNN NNNN NNNN NNNN NNNN', 'mask': 'AA99 9999 9999 9999 9999'}, 	
        'LU': {'placeholder': 'LUNN NNNX XXXX XXXX XXXX', 'mask': 'AA99 999* **** **** ****'}, 	
        'LV': {'placeholder': 'LVNN AAAA XXXX XXXX XXXX X', 'mask': 'AA99 AAAA **** **** **** *'}, 	
        'MC': {'placeholder': 'MCNN NNNN NNNN NNXX XXXX XXXX XNN', 'mask': 'AA99 9999 9999 99** **** **** *99'}, 	
        'MD': {'placeholder': 'MDNN XXXX XXXX XXXX XXXX XXXX', 'mask': 'AA99 **** **** **** **** ****'}, 	
        'ME': {'placeholder': 'MENN NNNN NNNN NNNN NNNN NN', 'mask': 'AA99 9999 9999 9999 9999 99'}, 	
        'MK': {'placeholder': 'MKNN NNNX XXXX XXXX XNN', 'mask': 'AA99 999* **** **** 999'}, 	
        'MR': {'placeholder': 'MR13 NNNN NNNN NNNN NNNN NNNN NNN', 'mask': 'AA13 9999 9999 9999 9999 9999 999'}, 	
        'MT': {'placeholder': 'MTNN AAAA NNNN NXXX XXXX XXXX XXXX XXX', 'mask': 'AA99 AAAA 9999 9*** **** **** **** ***'}, 	
        'MU': {'placeholder': 'MUNN AAAA NNNN NNNN NNNN NNNN NNNA AA', 'mask': 'AA99 AAAA 9999 9999 9999 9999 99NA AA'}, 	
        'NL': {'placeholder': 'NLNN AAAA NNNN NNNN NN', 'mask': 'AA99 AAAA 9999 9999 99'}, 	
        'NO': {'placeholder': 'NONN NNNN NNNN NNN', 'mask': 'AA99 9999 9999 99N'}, 	
        'PK': {'placeholder': 'PKNN AAAA XXXX XXXX XXXX XXXX', 'mask': 'AA99 AAAA **** **** **** ****'}, 	
        'PL': {'placeholder': 'PLNN NNNN NNNN NNNN NNNN NNNN NNNN', 'mask': 'AA99 9999 9999 9999 9999 9999 9999'}, 	
        'PS': {'placeholder': 'PSNN AAAA XXXX XXXX XXXX XXXX XXXX X', 'mask': 'AA99 AAAA **** **** **** **** **** *'}, 	
        'PT': {'placeholder': 'PT50 NNNN NNNN NNNN NNNN NNNN N', 'mask': 'AA50 9999 9999 9999 9999 9999 9'}, 	
        'QA': {'placeholder': 'QANN AAAA XXXX XXXX XXXX XXXX XXXX X', 'mask': 'AA99 AAAA **** **** **** **** **** *'}, 	
        'RO': {'placeholder': 'RONN AAAA XXXX XXXX XXXX XXXX', 'mask': 'AA99 AAAA **** **** **** ****'}, 	
        'RS': {'placeholder': 'RSNN NNNN NNNN NNNN NNNN NN', 'mask': 'AA99 9999 9999 9999 9999 99'}, 	
        'SA': {'placeholder': 'SANN NNXX XXXX XXXX XXXX XXXX', 'mask': 'AA99 99** **** **** **** ****'}, 	
        'SE': {'placeholder': 'SENN NNNN NNNN NNNN NNNN NNNN', 'mask': 'AA99 9999 9999 9999 9999 9999'}, 	
        'SI': {'placeholder': 'SINN NNNN NNNN NNNN NNN', 'mask': 'AA99 9999 9999 9999 999'}, 	
        'SK': {'placeholder': 'SKNN NNNN NNNN NNNN NNNN NNNN', 'mask': 'AA99 9999 9999 9999 9999 9999'}, 	
        'SM': {'placeholder': 'SMNN ANNN NNNN NNNX XXXX XXXX XXX', 'mask': 'AA99 A99N 9999 999* **** **** ***'}, 	
        'TN': {'placeholder': 'TN59 NNNN NNNN NNNN NNNN NNNN', 'mask': 'AA59 9999 9999 9999 9999 9999'}, 	
        'TR': {'placeholder': 'TRNN NNNN NXXX XXXX XXXX XXXX XX', 'mask': 'AA99 9999 9*** **** **** **** **'}, 	
        'VG': {'placeholder': 'VGNN AAAA NNNN NNNN NNNN NNNN', 'mask': 'AA99 AAAA 9999 9999 9999 9999'}
    };
        
    var onKey = function(key, result, $object) {
        if (result.pos === 1){
            var country = $object.val().slice(0,2);
            
            $object.inputmask('remove');
            if (typeof schema[country] === 'object'){                   
                $obj.attr('placeholder', schema[country]['placeholder']);
                
                $object.inputmask({
                    placeholder: schema[country]['placeholder'],                            
                    mask: schema[country]['mask'],                            
                    showMaskOnHover: true,
                    showMaskOnFocus: true,
                    clearMaskOnLostFocus: true,
                    onKeyValidation: function (key, result) {
                        onKey(key, result, $object);
                    },
                    onKeyDown: function(event, buffer, caretPos, opts){
                        if (caretPos === 0){
                            initMask();
                        }
                    }
                });
            } else {
                $object.val('');
                $object.inputmask('remove');
                initMask('AA - Bitte geben Sie einen gültigen Ländercode ein');
            }
        }
    };
        
    var initMask = function(placeholder) { 
        placeholder = placeholder || null;
        
        $obj.attr('placeholder', (typeof placeholder === 'string' ? placeholder : schema['default']['placeholder']));
        
        $obj.inputmask({
            mask: schema['default']['mask'],
            placeholder: schema['default']['placeholder'],
            greedy: false,
            showMaskOnHover: false,
            showMaskOnFocus: false,
            onKeyValidation: function (key, result) {
                onKey(key, result, $(this));
            },
            definitions: {
                'A': {
                    validator: "[A-Za-z]",
                    casing: "upper"
                }
            }
        });
    };
        
    if ($obj.val() !== ''){                              
        onKey(1, {pos: 1}, $obj);                
    } else {
        initMask();
    }
    
    var hasBeenRemoved = false;                
        
    $obj.bind('paste', function(event) {
        $obj.inputmask('remove');
        hasBeenRemoved = true;
        $obj.val(event.originalEvent.clipboardData.getData('text'));
    });

    $obj.on('input', function(){
        if ($obj.val() === '' && hasBeenRemoved){ 
            hasBeenRemoved = false;
            initMask();
        }
    });
};

var emailMask = function($obj) {
    $obj.inputmask({
        mask: "*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]",
        greedy: false,
        onBeforePaste: function (pastedValue, opts) {
            pastedValue = pastedValue.toLowerCase();
            return pastedValue.replace("mailto:", "");
        },
        definitions: {
            '*': {
                validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~\-]",
                casing: "lower"
            }
        }
    });
};

var birthdayMask = function($obj) {
    $obj.inputmask("99/99/9999",{ "placeholder": "DD/MM/RRRR" });
};

function init() {                   
    $('.js-inputmask').each(function() {
        var $me = $(this);
        var hasDefinitionData = $me.attr('data-inputmask');
        var hasAlias = $me.attr('data-mask');

        switch (hasAlias) {
            case 'email':
                emailMask($me);
                break;
            case 'iban':
                ibanMask($me);
                break;  
            case 'birthday':
                birthdayMask($me);
                break;
            default:
                if (typeof hasDefinitionData !== 'undefined') {
                    $me.inputmask();
                }
                break;
        }
    });
}

export const InputMasks = {
    init
}